import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Logo } from "./Logo";
import { NotificationBell } from "./NotificationBell";
import { PreviewToggle } from "./PreviewBar";
import { brand, hasCommunity } from "../lib/brand";

export function TopBar() {
  const { user, isAdmin, signOut } = useAuth();
  if (!user) return null;

  return (
    <header className="topbar">
      <div className="topbar__left">
        <Logo />
      </div>
      <div className="topbar__right">
        <nav className="topbar__nav">
          {hasCommunity(brand.id) && (
            <NavLink to="/chat" className={({ isActive }) => (isActive ? "active" : "")}>
              Chat โลก
            </NavLink>
          )}
          <NavLink to="/dashboard" className={({ isActive }) => (isActive ? "active" : "")}>
            คอร์สของฉัน
          </NavLink>
          {hasCommunity(brand.id) && (
            <NavLink to="/leaderboard" className={({ isActive }) => (isActive ? "active" : "")}>
              ลีดเดอร์บอร์ด
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/admin" end className={({ isActive }) => (isActive ? "active" : "")}>
              สถิติ
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/admin/students" className={({ isActive }) => (isActive ? "active" : "")}>
              สมาชิก
            </NavLink>
          )}
        </nav>
        <NotificationBell userId={user.uid} />
        {isAdmin && <span className="admin-badge">แอดมิน</span>}
        <PreviewToggle />
        <Link to="/profile" className="btn-ghost">
          โปรไฟล์
        </Link>
        <button className="btn-secondary" onClick={signOut}>
          ออกจากระบบ
        </button>
      </div>
    </header>
  );
}
